<div
  class="flex flex-col flex-wrap gap-3 border-b border-neutral-200 pb-3 md:mb-4 md:flex-row md:items-center md:gap-4 md:px-3 md:pb-4"
>
  <div class="flex justify-between gap-3 md:contents">
    <div class="flex items-center gap-3 md:gap-4">
      @if (question().completed) {
        <dojo-icon icon="circle-check" [iconClass]="'text-sky-500'" [size]="18" [faPrefix]="'fas'" />
      } @else {
        <dojo-icon
          icon="circle-dashed"
          [iconClass]="'text-neutral-300'"
          [size]="18"
          [matTooltip]="'question_bank.not_done' | transloco"
          [matTooltipPosition]="'above'"
        />
      }
      <div class="font-primary text-primary text-md">[Maximum mark: {{ totalMarks() }}]</div>
    </div>
    <div class="flex items-center gap-4">
      <dojo-difficulty [difficulty]="difficulty()" />
      <dojo-calculator-indicator [calculatorAllowed]="question().metadata?.calculator_allowed ?? false" />

      <div class="hidden h-4 w-px bg-neutral-200 md:block"></div>
    </div>
  </div>

  <div class="flex flex-1 items-center gap-4 empty:hidden">
    <ng-content />
  </div>
</div>
